module.exports = __webpack_public_path__ + "img/cycle-step-success.c4a5a0b6.svg";